import "./styles.scss";
import { Link } from "react-router-dom";
import LogoImg from "../../assets/logo.png";
import { UserContext } from "../../context/UserContext";
import { useContext } from "react";

export function SideMenu() {
  function closeNav() {
    let menu = document.querySelector("#menu").style;
    menu.width = "0px";
  }

  function openNav() {
    let menu = document.querySelector("#menu").style;
    menu.width = "250px";
  }

  const { userLogout, user } = useContext(UserContext);

  return (
    <>
      <nav>
        <div className="topBar">
          <div className="imgContainer">
            <button className="openBtn" onClick={openNav}>
              <i className="fas fa-bars"></i>
            </button>
            <Link to="/moderation">
              <img src={LogoImg} alt="Logo" />
            </Link>
          </div>

          <div className="logout">
            <button onClick={() => userLogout()}>
              <i className="fas fa-sign-out-alt"></i>
            </button>
          </div>
        </div>
      </nav>

      <aside>
        <nav id="menu" className="sideNav">
          <button className="closeBtn" onClick={closeNav}>
            <i className="fas fa-times"></i>
          </button>
          {user && user.fk_id_type == 1 ? (
            <div className="link">
              <Link to="/moderation">Moderação</Link>
              <Link to="/users">Usuários</Link>
              <Link to="/campain">Campanhas</Link>
              <Link to="/client">Client</Link>
              <Link to="/app">App</Link>
            </div>
          ) : (
            <div className="link">
              <Link to="/moderation">Moderação</Link>
            </div>
          )}
        </nav>
      </aside>
    </>
  );
}
